import { useSearchParams } from "react-router-dom";

type CaseContextParams = {
  queueId: string | undefined;
  filterParams: Record<string, string>;
};

export const useCaseContextParams = (): CaseContextParams => {
  const [searchParams] = useSearchParams();

  const entries = [...searchParams.entries()];

  return {
    queueId: searchParams.get("queueId") ?? undefined,
    filterParams: Object.fromEntries(
      entries.filter(([key]) => key.startsWith("filter[")),
    ),
  };
};
